import Vue from "vue";
import { CardModel } from "../../models/contracts/cardModel";
import { ContractModel } from "../../models/contracts/contractModel";
import { ContractsStore } from "../../store/modules/contracts";
import { getModule } from "vuex-module-decorators";
import { StatementModel } from "../../models/statement/statementModel";

export class StatementVue extends Vue {
  /**Стор счетов */
  get contractsStore(): ContractsStore {
    return getModule(ContractsStore, this.$store);
  }

  get contract(): ContractModel {
    return this.contractsStore.contracts.getContract(
      +this.$route.params.contractId
    );
  }

  get card(): CardModel {
    return this.contractsStore.contracts.getCard(
      +this.$route.params.contractId,
      +this.$route.params.cardId
    );
  }

  get statementObject(): StatementModel {
    if (this.contract) {
      if (+this.$route.params.cardId) {
        return this.card.StatementModel;
      }
      return this.contract.StatementModel;
    }
    return null;
  }
}
